module.exports = __webpack_public_path__ + "img/arrow_down.f25f282f.svg";